<template>
  <div class="IntroSlide4 lxn-w100 lxn-viewWithMaxWidth">
    <div class="IntroSlide4-d0">
      <CurveWithSvg :hideCurve="true">
        <template v-slot:svg>
          <svg class="lxn-w100 lxn-h100 lxn-display-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250"><circle cx="125" cy="125" r="125" fill="#fbb25d"/><path d="M68.55 147.15l-2.12 12.7 3.65 7.3a2.11 2.11 0 0 0 1.89 1.17h111.7a2.11 2.11 0 0 0 1.89-1.17l3.65-7.3-2.12-12.7H68.55z" fill="#2c2f38"/><path d="M187.1 111.54H68.55l-2.12 6.04v42.27h122.8V115.4z" fill="#35495e"/><path d="M66.43 140.8h61.4v19.05h-61.4zm0-25.4h61.4v16.94h-61.4z" fill="#2c3e50"/><path d="M66.43 132.33h61.4v8.47h-61.4z" fill="#2c2f38"/><circle cx="168.05" cy="136.56" r="6.35" fill="#1ea5de"/><path d="M183.78 104.5l-2.6-5.2-5.36-10.7-6.86-13.7c-.54-1.08-2.18-1.82-4.04-1.82H90.74c-1.86 0-3.5.74-4.04 1.82L66.44 115.4h122.8l-5.45-10.9z" fill="#35495e"/><path d="M189.22 115.4h-61.4V73.1h37.1c1.86 0 3.5.74 4.04 1.82l6.86 13.7 7.96 15.9 5.45 10.9z" fill="#2c3e50"/><path d="M87.06 91.1c-1.12-.2-2.3.18-2.64.86l-1.28 2.56c-.23.44-.04.92.47 1.25s1.3.48 2.03.37 1.33-.44 1.54-.88l1.28-2.56c.16-.33.1-.68-.16-.98-.25-.3-.7-.52-1.24-.62zM94.12 77c-1.12-.2-2.3.18-2.64.86L87 86.82c-.34.68.3 1.4 1.4 1.6.2.04.4.05.62.06.93 0 1.76-.37 2.03-.9l4.5-8.97c.33-.7-.3-1.4-1.42-1.6z" fill="#3f5c6c"/><path d="M145.6 115.4h-6l-11.75-7.13v-3.6zm21.92 0h-6L127.82 95v-3.63zm19.5 0h-6l-53.2-32.22v-3.62zm-3.24-10.9L131.9 73.1h6l43.3 26.2zm-7.96-15.9l-25.66-15.5h6.02l17.04 10.33z" fill="#2c2f38"/></svg>
        </template>
      </CurveWithSvg>
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="IntroSlide4-title lxn-w100 lxn-title lxn-text-center">
      {{$store.getters.language.texts.IntroSlide4_title}}
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="IntroSlide4-text lxn-w100 lxn-text lxn-text-justify">
      {{$store.getters.language.texts.IntroSlide4_text}}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CurveWithSvg from '@/components/CurveWithSvg.vue'

export default {
  name: 'IntroSlide4',
  components: {
    CurveWithSvg,
  },
  data: function() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style>
  .IntroSlide4 {
    background-color: transparent;
    min-height: 300px;
  }
  .IntroSlide4-d0 {
    height: 40vh;
  }
  .IntroSlide4-title {
    margin-top: 20px;
    height: 30px;
    color: #1EA5DE;
    line-height: 30px;
  }
  .IntroSlide4-text {
    color: #53636C;
    margin-top: 20px;
  }
</style>
